import React from "react";
import { useAuth } from "../authentication/useAuth";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import Button from "../button/Button";

const AdminModeBanner: React.FC = () => {
  const { isAdminMode, onLogout, user } = useAuth();
  const { t } = useCustomTranslation();

  if (!isAdminMode) {
    return null;
  }

  return (
    <div className="bg-gray fixed top-1/2 right-4 z-50 flex -translate-y-1/2 flex-col items-center gap-3 rounded-lg border border-orange-400 px-4 py-3 shadow-lg">
      <div className="flex items-center gap-2">
        <div className="flex flex-col">
          <span className="text-sm font-semibold text-orange-800">
            {t("admin_mode_active")}
          </span>
          <span className="text-xs text-orange-600">
            {t("logged_in_as", { name: user?.fullName })}
          </span>
        </div>
      </div>
      <Button
        size="small"
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          onLogout();
        }}
        label={t("logout")}
      />
    </div>
  );
};

export default AdminModeBanner;
